/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilebillinginvoices2Inputs */

const en_profilebillinginvoices2 = /** @type {(inputs: Profilebillinginvoices2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoices and payment`)
};

const de_profilebillinginvoices2 = /** @type {(inputs: Profilebillinginvoices2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungen und Zahlung`)
};

/**
* | output |
* | --- |
* | "Invoices and payment" |
*
* @param {Profilebillinginvoices2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebillinginvoices2 = /** @type {((inputs?: Profilebillinginvoices2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebillinginvoices2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebillinginvoices2(inputs)
	return de_profilebillinginvoices2(inputs)
});
export { profilebillinginvoices2 as "profileBillingInvoices" }